import React from 'react'
import classNames from 'classnames'

import './Image.scss'

import placeholder from '../../../assets/common/placeholder.png'
import { ThemeSpacing } from '../../../types/theme'

export interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string
  size?: ThemeSpacing
  alt: string
  shadow?: boolean
  src: string | undefined
  circle?: boolean
  widthSize?: ThemeSpacing
  heightSize?: ThemeSpacing
  cover?: boolean
  contain?: boolean
}

function Image ({ size, src, className, alt, circle, shadow, widthSize, heightSize, cover, contain, ...rest }: Props) {
  const sizeClass = size ? `size-${size}` : null
  const widthClass = widthSize ? `width-${widthSize}` : null
  const heightClass = heightSize ? `height-${heightSize}` : null
  return (
    <img
      className={classNames('image', { shadow, circle, cover, contain }, sizeClass, widthClass, heightClass, className)}
      alt={alt}
      src={src ?? placeholder}
      {...rest}
    />
  )
}

export default Image
